/**
 * 基于requestAnimationFrame的节流
 * @param {*} fn 节流的函数
 * @return {Function} throttled 返回节流后的函数
 */
export function rafThrottle(fn) {
  let locked = false;
  return function (...args) {
    // this为any的时候报错，需指定this为any或unknown
    if (locked) return;
    locked = true;
    window.requestAnimationFrame(() => {
      fn.apply(this, args);
      locked = false;
    });
  };
}
